import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

const findIndividual = (data, field, value) => {
  return data?.filter(item => item[field] === value)[0];
};

function isAllObject(param) {
  if (param?.length > 0 && Array.isArray(param)) {
    for (let i = 0; i < param.length; i++) {
      if (
        !(
          typeof param[i] === 'object' &&
          param[i] !== null &&
          !Array.isArray(param[i])
        )
      ) {
        return false;
      }
    }
    return true;
  } else {
    return false;
  }
}

// Extend dayjs with the duration plugin
dayjs.extend(duration);
function convertStringToNumber(str) {
  // Remove any non-numeric characters except '.', '-', and '='
  const cleanedStr = str.replace(/[^\d.=]/g, '');

  // Replace multiple dots or equal signs with a single dot
  const normalizedStr = cleanedStr.replace(/[.=]+/g, '.');

  // Convert the string to a number
  const number = parseFloat(normalizedStr);

  // Check if the number is a valid number
  if (!isNaN(number)) {
    return number;
  } else {
    // Return NaN if the conversion fails
    return NaN;
  }
}

function removeSpecialCharsAndSpaces(str) {
  // Remove special characters and spaces using regular expression
  return str.replace(/[^\w\s]/gi, '').replace(/\s+/g, '');
}

function areStringsEqual(str1, str2) {
  // Remove special characters and spaces from both strings
  const cleanStr1 = removeSpecialCharsAndSpaces(str1);
  const cleanStr2 = removeSpecialCharsAndSpaces(str2);

  // Compare the cleaned strings for equality
  return cleanStr1 === cleanStr2;
}

const validDate = date => {
  if (date) {
    const [d, m, y] = date.split('-');
    return `${y}-${m},${d}`;
  } else {
    return date;
  }
};

const formatDate = (date, format, dateIsValid = true) => {
  if (date) {
    const validatedDate = dateIsValid ? date : validDate(date);
    return dayjs(validatedDate).format(format);
  } else {
    return date;
  }
};

function formatTimeToAmPm(timeString) {
  if (timeString) {
    const [hours, minutes] = timeString.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${minutes.toString().padStart(2, '0')} ${period}`;
  } else {
    return timeString;
  }
}

const getUserData = key => {
  const userDataJson = window.localStorage.getItem('kerpUserData2.1');
  const parsedUserData = JSON.parse(userDataJson || '{}');

  return parsedUserData[key];
};
const calculateDuration = (startDate, endDate) => {
  // Calculate the duration between the two dates
  const diffInMilliseconds = dayjs(endDate).diff(startDate);
  const duration = dayjs.duration(diffInMilliseconds);
  const difference = {
    day: duration.days(),
    hours: duration.hours(),
    min: duration.minutes(),
    sec: duration.seconds()
  };

  return difference;
};

const mergeParams = (...params) => {
  if (params) {
    return params.reduce((ob, current) => {
      return { ...ob, ...current };
    }, {});
  } else if (Array.isArray(params)) {
    params.reduce((arr, current) => {
      return [...arr, ...current];
    }, []);
  }

  throw new Error('All parameters should be either objects or arrays');
};

const getInitialValues = (...params) => {
  if (isAllObject(params)) {
    return params.reduce((acc, current) => {
      Object.keys(current).forEach(key => {
        acc[key] = '';
      }, {});
      return acc;
    }, {});
  } else {
    return {};
  }
};

const generateOptions = ({ data, valueKey, labelKey, descKey, formatter }) => {
  if (data?.length <= 0) {
    return [];
  }

  return data?.map(option => {
    if (typeof option === 'string' || typeof option === 'number') {
      return {
        label: option,
        value: option
      };
    }

    return formatter
      ? formatter(option)
      : {
          label: option[labelKey] || '',
          value: option[valueKey] || '',
          desc: descKey ? option[descKey] : ''
        };
  });
};

function isObjectNotEmpty(obj) {
  // Check if the object is not null or undefined
  if (obj === null || obj === undefined) {
    return false;
  }

  // also check if the object is Object
  if (typeof obj !== 'object') {
    return false;
  }

  return Object.keys(obj).length > 0;
}

export {
  convertStringToNumber,
  areStringsEqual,
  formatDate,
  calculateDuration,
  mergeParams,
  getInitialValues,
  formatTimeToAmPm,
  validDate,
  generateOptions,
  findIndividual,
  getUserData,
  isObjectNotEmpty
};
